import {IRoutableModule} from '../../../router/routing.infra';
import {DashboardMainDesktopView, DashboardMainMobileView} from './dashboard-main.view';
import {dashboardMainLoader} from './dashboard-main.loader';
import '@techsee/techsee-ui-common/lib/_shared/icons.css';
import '../views/DashboardNewView.scss';

export default {
    loader: dashboardMainLoader,
    Component: DashboardMainDesktopView,
    MobileComponent: DashboardMainMobileView,
    storeAs: 'dashboardMainStore'
} as IRoutableModule;
